
// import {useDraggable} from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import {theme} from 'antd';
import { CSSProperties } from 'react';

const { useToken } = theme;

export function Draggable(props: any) {
    const { token } = useToken();
  const {attributes, listeners, setNodeRef, transform, transition} = useSortable({
    id: props.id,
  });
  const style: CSSProperties =  {
    // Outputs `translate3d(x, y, 0)`
    transition: transition,
    transform: CSS.Translate.toString(transform),
    border: `1px solid ${props.bg === "#dcfdba" ? "#b7eb8f" : props.bg !== undefined ? props.bg : token.colorBorder}`,
    borderRadius: token.borderRadius,
    backgroundColor: props.bg,
    display: 'flex',
    alignItems: 'center',
    color: "black",
    cursor: "grab",
    padding: "5px 12px",
    zIndex: 5
    
  };

  return (
    <div ref={setNodeRef} style={style} {...listeners} {...attributes}>
      {props.children}
    </div>
  );
}
